export const countries: Country[] = [
  { name: 'Canada', value: 'Canada' },
  { name: 'Malaysia', value: 'Malaysia' },
  { name: 'Singapore', value: 'Singapore' },
  { name: 'United Arab Emirates', value: 'United Arab Emirates' },
  { name: 'United Kingdom', value: 'United Kingdom' },
  { name: 'United States', value: 'United States' },
  { name: 'Other', value: 'Other' },
];

export interface Country {
  name: string;
  value: string;
  index?: number;
}
